import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import PlaySquareTwoToneSvg from "@ant-design/icons-svg/es/asn/PlaySquareTwoTone";
import AntdIcon from "../components/AntdIcon";
var PlaySquareTwoTone = function PlaySquareTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PlaySquareTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  PlaySquareTwoTone.displayName = 'PlaySquareTwoTone';
}
export default /*#__PURE__*/React.forwardRef(PlaySquareTwoTone);